<template>

  <v-container fluid>
    
    <!-- 승인팝업 -->
    <v-row>
        <v-dialog scrollable overlay-color="#00000040" persistent v-model="dialogstate" @keydown.esc="dialogstate = false" max-width="500px">
          <v-card class="dialog_round pa-10">
            <v-row dense align="center">
              <v-col cols="11" md="11" sm="11" xs="11">
                <span class="dialog_title">{{$t("company_apopup_title")}}</span>
              </v-col>
              <v-col cols="1" md="1" sm="1" xs="1">
                <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialogstate = false"><v-icon>mdi-close</v-icon></v-btn>
              </v-col>
            </v-row>
            <v-row dense justify="center">
              <v-col cols="12" md="12" sm="12" xs="12">
                <div style="background:#4e6ef7;height:2px;" />
              </v-col>
            </v-row>
            <v-card-text>
              <v-container>
                <v-row>
                  <label>{{$t("company_apopup_label1")}}</label>
                  <label>{{$t("company_apopup_label2")}}</label>
                </v-row>
                <v-row>
                  <v-select v-model="editedItem.STATE" :items="STATELIST" class="mt-3"
                  outlined :label="$t('company_apopup_label3')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-row justify="center">
              <v-btn class="dialog_cancel_btn mr-5" rounded large @click="dialogstate = false">{{$t("common_cancel")}}</v-btn>
              <v-btn class="dialog_btn" rounded large @click="savestate">{{$t("common_save")}}</v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>  
    </v-row>

    <!-- 팝업 -->
    <v-row>
        <v-dialog scrollable overlay-color="#00000040"  v-model="dialog" @keydown.esc="close" max-width="800px">
          <v-card class="dialog_round pa-10">

            <v-row dense align="center">
              <v-col cols="11" md="11" sm="11" xs="11">
                <span class="dialog_title">{{ dialogTitle }}</span>
              </v-col>
              <v-col cols="1" md="1" sm="1" xs="1">
                <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
              </v-col>
            </v-row>
            <v-row dense justify="center">
              <v-col cols="12" md="12" sm="12" xs="12">
                <div style="background:#4e6ef7;height:2px;" />
              </v-col>
            </v-row>

            <v-card-text>
              <v-container>
                <v-row dense  align="center" justify="center">
                  <v-col cols="3">
                    <label>{{$t("join_comkor")}}</label><label style="color:red">*</label>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="editedItem.NAME"
                      dense single-line clearable
                      :placeholder="$t('join_comkor_holder')"
                      outlined height="43"
                      color="red"
                      hide-details
                      />
                  </v-col>
                </v-row>

                <v-row dense  align="center" justify="center">
                  <v-col cols="3">
                    <label>{{$t("join_comeng")}}</label><label style="color:red">*</label>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="editedItem.ENAME"
                      dense single-line clearable
                      :placeholder="$t('join_comeng_holder')"
                      outlined height="43"
                      color="red"
                      hide-details
                      />
                  </v-col>
                </v-row>

                <v-row dense  align="center" justify="center">
                  <v-col cols="3">
                    <label>{{$t("join_ceo")}}</label><label style="color:red">*</label>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="editedItem.CEONAME"
                      dense single-line clearable
                      :error-count="$t('join_ceo_holder')"
                      outlined height="43"
                      color="red"
                      hide-details
                      />
                  </v-col>
                </v-row>

                <v-row dense  justify="center">
                  <v-col cols="3">
                    <label>{{$t("join_number")}}</label><label style="color:red">*</label>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="editedItem.TEL"
                      counter maxlength="30"
                      dense single-line clearable
                      :placeholder="$t('join_number_holder')"
                      outlined height="43"
                      color="red"
                      :rules="[value => !value || !/[^0-9+-]/.test(value) || $t('join_phone_rule')]"
                      />
                  </v-col>
                </v-row>

                <v-row dense justify="center">
                  <v-col cols="3">
                    <label>{{$t("join_email")}}</label><label style="color:red">*</label>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="editedItem.EMAIL"
                      maxlength="30" counter
                      dense single-line clearable
                      :placeholder="$t('join_email_holder')"
                      outlined height="43"
                      color="red"
                      />
                  </v-col>
                </v-row>

                <v-row dense  justify="center">
                  <v-col cols="3">
                    <label>{{$t("join_mobile")}}</label><label style="color:red">*</label>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="editedItem.MOBILE"
                      counter maxlength="20"
                      dense single-line clearable
                      :placeholder="$t('join_mobile_holder')"
                      outlined height="43"
                      color="red"
                      :rules="[value => !value || !/[^0-9-]/.test(value) || $t('join_mobile_rule')]"
                      />
                  </v-col>
                </v-row>

                <v-row dense  align="center" justify="center">
                  <v-col cols="3">
                    <label>{{$t("join_addr1")}}</label><label style="color:red">*</label>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="editedItem.ADDR1"
                      dense single-line clearable disabled
                      :placeholder="$t('join_addr1_holder')"
                      outlined height="43"
                      color="red"
                      hide-details
                      />
                  </v-col>
                  <v-col cols="3" align="center">
                    <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="postcode">{{$t("join_addr_btn")}}</v-btn>
                  </v-col>
                </v-row>

                <v-row dense  align="center" justify="center">
                  <v-col cols="3">
                    <label>{{$t("join_addr2")}}</label><label style="color:red">*</label>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      counter="100" color="red"
                      v-model="editedItem.ADDR2"
                      dense single-line clearable
                      :placeholder="$t('join_addr2_holder')"
                      outlined height="43"
                      hide-details
                      :rules="[ v => ( v != null && v.length <= 100) || $t('join_addr2_rules') ]"
                      />
                  </v-col>
                </v-row>

                <v-row dense justify="center">
                  <v-col cols="3">
                    <label>{{$t("join_comnumber")}}</label><label style="color:red">*</label>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      counter maxlength="20"
                      v-model="editedItem.REGNUMBER"
                      dense single-line clearable
                      :placeholder="$t('join_comnumber_holder')"
                      outlined height="43"
                      color="red"
                      :rules="[value => !value || !/[^0-9-]/.test(value) || $t('join_serial_rule')]"
                      />
                  </v-col>
                  <v-col cols="3" align="center">
                    <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="checkRegNumber">{{$t("join_id_check")}}</v-btn>
                  </v-col>
                </v-row>

                <v-row dense  align="center" justify="center">
                  <v-col cols="3">
                    <label>{{$t("join_bank")}}</label><label style="color:red">*</label>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="editedItem.BANKTYPE"
                      dense single-line clearable
                      :placeholder="$t('join_bank_holder')"
                      outlined height="43"
                      color="red"
                      hide-details
                      />
                  </v-col>
                </v-row>

                <v-row dense justify="center">
                  <v-col cols="3">
                    <label>{{$t("join_banknumber")}}</label><label style="color:red">*</label>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      counter maxlength="30"
                      v-model="editedItem.BANKNUMBER"
                      dense single-line clearable
                      :placeholder="$t('join_banknumber_holder')"
                      outlined height="43"
                      color="red"
                      :rules="[value => !value || !/[^0-9-]/.test(value) || $t('join_serial_rule')]"
                      />
                  </v-col>
                </v-row>

                <v-row dense  align="center" justify="center">
                  <v-col cols="3">
                    <label>{{$t("company_logo")}}</label><label style="color:red">*</label>
                  </v-col>
                  <v-col cols="9">
                    <v-file-input 
                      outlined dense height="43"
                      show-size :label="$t('company_logo_label')" hide-details
                      v-model="uploadFile"
                      accept="image/png, image/jpeg"
                      @change="change_file"
                      >
                      </v-file-input>
                  </v-col>
                </v-row>

                <v-row align="center" justify="center">
                  <viewer
                    class="viewer"
                    ref="viewer" 
                    :options="options"
                    >
                    <img 
                      height="100" style="background:#808080;"
                      :src="previewImg"
                      class="image"
                      >
                  </viewer>
                </v-row>                

                <v-row dense  align="center" justify="center">
                  <v-col cols="3">
                    <label>{{$t("join_comimg")}}</label><label style="color:red">*</label>
                  </v-col>
                  <v-col cols="9">
                    <v-file-input 
                      outlined dense height="43"
                      show-size :label="$t('join_comimg_label')" hide-details
                      v-model="uploadFile2"
                      accept="image/png, image/jpeg"
                      >
                      </v-file-input>
                  </v-col>
                </v-row>

                <v-row align="center" justify="center">
                  <viewer
                    class="viewer"
                    ref="viewer" 
                    :options="options"
                    >
                    <img 
                      height="100" style="background:#808080;"
                      :src="editedItem.REGIMG"
                      class="image"
                      >
                  </viewer>
                </v-row>

                <v-row dense  align="center" justify="center">
                  <v-col cols="3">
                    <label>{{$t("join_bankimg")}}</label><label style="color:red">*</label>
                  </v-col>
                  <v-col cols="9">
                    <v-file-input 
                      outlined dense height="43"
                      show-size :label="$t('join_bankimg_label')" hide-details
                      v-model="uploadFile3"
                      accept="image/png, image/jpeg"
                      >
                      </v-file-input>
                  </v-col>
                </v-row>  

                <v-row align="center" justify="center">
                  <viewer
                    class="viewer"
                    ref="viewer"
                    :options="options"
                    >
                    <img
                      height="100" style="background:#808080;"
                      :src="editedItem.BANKIMG"
                      class="image"
                      >
                  </viewer>
                </v-row>


                <v-row dense  align="center" justify="center">
                  <v-col cols="3">
                    <label>APIKEY</label><label style="color:red">*</label>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="editedItem.APIKEY"
                      dense single-line clearable
                      :placeholder="$t('company_api_holder')"
                      disabled
                      outlined height="43"
                      color="red"
                      hide-details
                      />
                  </v-col>
                </v-row>
                <v-row v-if="editedItem.APIKEY != null && editedItem.APIKEY.length == 0" dense align="center" justify="center">
                  <v-col cols="3">
                  </v-col>
                  <v-col cols="9" align="center">
                    <label>{{$t("company_api_msg")}}</label>
                  </v-col>
                  <v-col cols="3"></v-col>
                  <v-col cols="9" align="center">
                    <v-btn style="width:50%" class="search_btn_freesize" elevation="0" outlined @click="createAPIKey(editedItem.IDX)">Create API KEY</v-btn>
                  </v-col>
                </v-row>    

                <v-row dense align="center" justify="center">
                  <v-col cols="3">
                    <label>{{$t("company_api_state")}}</label><label style="color:red">*</label>
                  </v-col>
                  <v-col cols="9">
                    <v-select outlined dense v-model="editedItem.API_STATE" hide-details :items="APISTATELIST" :label="$t('common_select')" 
                      :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
                  </v-col>
                </v-row>

              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-row justify="center">
              <v-btn class="dialog_cancel_btn mr-5" rounded large @click="close">{{$t("common_cancel")}}</v-btn>
              <v-btn class="dialog_btn" rounded large @click="save">{{$t("common_save")}}</v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>  
    </v-row>

    <!-- 이미지 크롭 팝업 (가로) -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="crop_dialog_land" @keydown.esc="crop_dialog_land = false" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t("common_crop")}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="crop_dialog_land = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <div style="width:100%;height:500px;">
              <vueCropper
                ref="cropper_land"
                :img="imgSrc"
                :outputType="option.outputType"
                :fixed="option.fixed"
                :fixedNumber="option.fixedNumber"
                :full="option.full"
                :canMove="option.canMove"
                :canMoveBox="option.canMoveBox"
                :fixedBox="option.fixedBox"
                :original="option.original"
                :autoCrop="option.autoCrop"
                :autoCropWidth="option.autoCropWidth"
                :autoCropHeight="option.autoCropHeight"
                :centerBox="option.centerBox"
                :high="option.high"
                :infoTrue="option.infoTrue"
                :maxImgSize="option.maxImgSize"
                :enlarge="option.enlarge"
                :mode="option.mode"
                :limitMinSize="option.limitMinSize"
                />
            </div>
            <!-- 
            <vue-cropper
                ref="cropper_land"
                :aspectRatio="16/9"
                :src="imgSrc"
                preview=".preview"
                />
            -->
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="crop_dialog_land = false">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="cropimg">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>


    <v-row dense align="center">
      <v-col cols="12" md="3" sm="12" xs="12" class="pa-0">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      
      <v-spacer/>

      <!-- 검색어 -->
      <template v-if="grade >= 90">
        <v-col cols="12" md="3">
          <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
        </v-col>
      </template>
      <v-col cols="12" md="3" class="pa-0">
        <v-text-field 
          dense single-line clearable
          @keyup.enter="search_run" 
          v-model="search_keyword" 
          :placeholder="$t('common_search_holder')"
          outlined height="43"
          color="#808080"
          hide-details
          />
      </v-col>
      <v-col cols="2" md="1" class="pa-0" align="center">
        <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="search_run">{{$t("common_search")}}</v-btn>
      </v-col>
      <v-col cols="2" md="1" class="pa-0" align="center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#ffffff;background:#0078d4" class="mr-1" elevation="1" small @click="joincompany()"><v-icon>mdi-account-plus</v-icon></v-btn>
          </template>
          <span>{{$t('common_join')}}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#ffffff;background:#0078d4" class="mr-1" elevation="1" small @click="startDownload()"><v-icon>cloud_download</v-icon></v-btn>
          </template>
          <span>{{$t("common_downexcel")}}</span>
        </v-tooltip>
      </v-col>

      <!-- 
      <v-col cols="2" md="1" sm="2" xs="2" class="pa-0" align="center">
        <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="newinsert">{{$t("common_insert")}}</v-btn>
      </v-col>
      -->
      
  </v-row>
  <v-row dense no-gutters>
    <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
  </v-row>
  <v-row align="start">
    <v-col class="pa-1">
      <!-- 테이블 -->
      <v-data-table
        class="datatablestyle"
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        :items-per-page="pagerow"
        :search="search"  
        item-key="IDX"
        :loading="loading"
        >
        <template v-slot:header.IDX>
          <a :class="sort_name=='IDX'?'cheader_sortselect':'cheader_sort'" @click="customsort('IDX')">{{$t("company_col1")}}</a>
        </template>
        <template v-slot:header.PARENT_NAME>
          <a :class="sort_name=='PARENT_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('PARENT_NAME')">{{$t("company_col9")}}</a>
        </template>
        <template v-slot:header.NAME>
          <a :class="sort_name=='NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('NAME')">{{$t("company_col2")}}</a>
        </template>
        <template v-slot:header.LOGO>
          <label class="cheader_normal" >{{$t("company_col3")}}</label>
        </template>
        <template v-slot:header.CEONAME>
          <label class="cheader_normal" >{{$t("company_col4")}}</label>
        </template>
        <template v-slot:header.TEL>
          <label class="cheader_normal" >{{$t("company_col5")}}</label>
        </template>

        <template v-slot:header.STATE>
          <a :class="sort_name=='STATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('STATE')">{{$t("company_col6")}}</a>
        </template>
        <template v-slot:header.REG_DATE>
          <a :class="sort_name=='REG_DATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('REG_DATE')">{{$t("company_col7")}}</a>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("comacnt_col5")}}</label>
        </template>

        <!-- 특정 컬럼 커스텀 처리 -->
        <template v-slot:item.LOGO="{ item }">
          <v-img :src="item.LOGO" height="40" aspect-ratio="1" contain/>
        </template>

        <template v-slot:item.STATE="{ item }">
          <template v-if="item.STATE == 0">
            <a style="color:red" @click="setstatecom(item)">{{$t("company_state1")}}</a>
          </template>
          <template v-else-if="item.STATE == 1">
            <a style="color:green" @click="setstatecom(item)">{{$t("company_state2")}}</a>
          </template>
          <template v-else>
            <a style="color:gray" @click="setstatecom(item)">{{$t("company_state3")}}</a>
          </template>
        </template>

        <!-- 액션처리 - 아이템 슬롯을 재정의 할 수 있지만 기본값이 반응형에 더 최적화 되어있다. -->
        <template v-slot:item.actions="{ item }">  
            <v-icon class="mr-2" small @click="edit_item(item)">mdi-pencil</v-icon>
            <v-icon v-if="grade > 90" small @click="delete_item(item)">mdi-delete</v-icon>
        </template>     
      </v-data-table>
    </v-col>
  </v-row>

  <!-- 하단 페이징 영역 -->
  <v-row align="center">
    <v-col cols="12" md="1"/>
    <v-col cols="12" md="2">
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('common_filter')"
        single-line
        hide-details
        outlined height="43"
        color="#808080"
        dense
        />
    </v-col>
    <v-col cols="12" md="6" class="d-flex justify-center">
      <v-btn v-if="bottompage > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <span v-for="n in subpage" :key="n.id">
          <span v-if="page == bottompage-1+n">
              <v-btn color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
          <span v-else>
              <v-btn icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
      </span>
      <v-btn v-if="subpage == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        v-model="pagerow"
        :items="pagerow_combo"
        item-text="NAME"      
        item-value="VALUE"
        :label="$t('common_rownum')"
        min-width="150px"
        outlined height="43"
        color="#808080"
        dense
        ></v-select>
    </v-col>
    <v-col cols="12" md="1"/>
  </v-row>

  
  

  </v-container>
</template>

<script type="text/javascript" src="//dapi.kakao.com/v2/maps/sdk.js?appkey=82fc565ca4c226a9f8b7d9f0b9253275&libraries=services"></script>
<script>
import 'cropperjs/dist/cropper.css';
import AWS from 'aws-sdk';  
import moment from 'moment'
import { VueCropper } from 'vue-cropper'; //교체용 크롭 라이브러리
import XLSX from 'xlsx'
export default {
    components:{
      VueCropper
    },
    data: () => ({
      
      s3: null,   //aws
      api_dialog: false,
      
      //파일 업로드
      uploadFile  : null,
      uploadFile2 : null,
      uploadFile3 : null,
      
      FILEPATH1:"",
      FILEPATH2:"",
      FILEPATH3:"",
      
      previewImg:"",
      
      CHECKREGNUMBER:"",
      images:[],
      options: {
        focus:false,
      },      

      crop_dialog_land: false,
      imgSrc:'',
      ratio: 16/9,

      //필수 페이징 파라메터
      totalcnt : 0,       //전체 아이템 개수
      page : 0,
      maxpage : 0,        //전체 페이지 개수
      startpage : 1,      //시작 인덱스
      bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      dialogstate:false,
      
      defaultItem: {
          NAME:'',
          LOGO:''
      },
      editedItem: {
      },

      sort_name: 'REG_DATE',
      sort_type: true,    //true : DESC, false: ASC

      //테이블 정의
      headers: [
      ],
      itemList: [],

      search_keyword : '',
      search: '',         //필터링용 검색어

      //한 페이지 ROW 개수 설정
      pagerow : 20,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
      ],    

      STATELIST: [
          {name:'사용신청', name2:'Application for Use',  value:0}
        , {name:'사용승인', name2:'Approval for Use',  value:1}
        , {name:'사용거부', name2:'Denial of Use',  value:2}
      ],
         
      APISTATELIST:[
          {name:'사용',     name2:'Use',    value:0}
        , {name:'사용불가', name2:'Unavailable',    value:1}
      ],

      //신규 크롭 파라메터
      option: {
        img: "",
        size: 1,
        full: true,
        outputType: "png",
        canMove: true,
        fixed: true,          //크롭박스 비율 고정
        fixedNumber: [16,9],  //크롭박스 비율
        fixedBox: false,      //true면 크롭박스 크기 조절 안됨
        original: false,      //true면 이미지의 원본 크기로 불러와지고 false면 편집창 기준에 맞게 불러와진다.
        canMoveBox: true,
        autoCrop: true,       //true면 자동으로 크롭박스가 표시됨.
        autoCropWidth:400,    //크롭박스의 가로 크기 fixed가 true면 비율대로
        autoCropHeight:400,   //크롭박스의 세로 크기 
        centerBox: true,
        high: false,
        cropData: {},
				enlarge: 1,
        mode: 'contain',
        maxImgSize: 1500,
        limitMinSize: [300, 300]
      },      
      selectFile:null,

      SEARCH_COM_IDX: '',
      SEARCH_COM_NAME: '',
      grade:0,

    }),

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.headers = [
        {text: this.$t("company_col1"),  value: 'IDX', sortable: false, align:'center'},
        {text: this.$t("company_col9"),  value: 'PARENT_NAME',  width:'150', sortable: false, align:'center'},
        {text: this.$t("company_col2"),  value: 'NAME', width:'250', sortable: false, align:'center'},
        {text: this.$t("company_col3"),  value: 'LOGO', sortable: false, align:'center'}, 
        {text: this.$t("company_col4"),  value: 'CEONAME', sortable: false, align:'center'},
        {text: this.$t("company_col5"),  value: 'TEL', sortable: false, align:'center'},
        {text: this.$t("company_col6"),  value: 'STATE', sortable: false, align:'center'},
        {text: this.$t("company_col7"),  value: 'REG_DATE', sortable: false, align:'center'},
        {text: this.$t("company_col8"),  value: 'actions', sortable: false, align:'center'}
      ];

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    methods: {

      joincompany(){
        this.$router.push({path:"Join", query:{PARENT_COM_IDX:this.SEARCH_COM_IDX}});
      },

      startDownload(){

        this.$confirm(this.$t('company_exceldown')).then(() => {

          this.loading = true;

          this.$http.post(this.$host+'/api/CompanyListExcel',{
                search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , sort_name:this.sort_name
              , sort_type: this.sort_type==true ? "DESC" : "ASC" 
              , LAN_CODE: this.$i18n.locale
              , ADMIN_IDX:this.$session.get("ADMIN_IDX")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                
                const list = result.data.resultData;
                var item_sheet = XLSX.utils.json_to_sheet(list);
                
                //컬럼명 수정
                item_sheet.A1 = {v:this.$t('company_col1')};
                item_sheet.B1 = {v:this.$t('company_excel1')};
                item_sheet.C1 = {v:this.$t('company_excel2')};
                item_sheet.D1 = {v:this.$t('company_col4')};
                item_sheet.E1 = {v:this.$t('company_excel3')};
                item_sheet.F1 = {v:this.$t('company_excel4')};
                item_sheet.G1 = {v:this.$t('company_excel5')};
                item_sheet.H1 = {v:this.$t('company_excel6')};
                item_sheet.I1 = {v:this.$t('company_excel7')};
                item_sheet.J1 = {v:this.$t('company_excel8')};
                item_sheet.K1 = {v:this.$t('company_excel9')};
                item_sheet.L1 = {v:this.$t('company_excel10')};
                item_sheet.M1 = {v:this.$t('company_excel11')};

                //컬럼별 너비
                var wscols = [{wch:10},{wch:20},{wch:20},{wch:10},{wch:20,},{wch:30},{wch:20},{wch:40},{wch:30},{wch:20},{wch:20},{wch:20}];
                item_sheet['!cols'] = wscols;

                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, item_sheet, 'info');
                XLSX.writeFile(wb, 'cominfo_'+moment().format('YYYYMMDDHHmmss')+'.xlsx');

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

        });

      },      

      savestate(){
        if(this.editedItem.STATE == 0){
          this.$alert(this.$t("company_savestate1"));
          this.dialogstate = false;
        }else if(this.editedItem.STATE == 1){
          this.$confirm(this.$t("company_savestate2"))
          .then(() => {
            this.sendchangeState(1);
            this.dialogstate = false;
          });
        }else if(this.editedItem.STATE == 2){
          this.$confirm(this.$t("company_savestate3"))
          .then(() => {
            this.sendchangeState(2);
            this.dialogstate = false;
          });
        }
      },

      sendchangeState(state){
        this.$http.post(this.$host+'/api/CompanyStateUpdate',{
              STATE: state
            , COM_IDX: this.editedItem.IDX
            , ADMIN_IDX: this.$session.get("ADMIN_IDX")
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          this.loading = false;
          if(result.data.resultCode == 0){
            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            this.$alert(this.$t('common_process_msg')).then(()=>{
              const p = this.page;
              this.page = 0;
              this.loadpage(p);
            });

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동
          }else{
              this.$alert(this.$t('common_process_fail'));
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
          this.$alert(this.$t('common_process_fail'));
        });

      },

      change_file(){
        
        //파일명 백업
        this.selectFile = this.uploadFile.name;

        //이미지 크롭 팝업 띄우기
        const reader = new FileReader();
        reader.onload = (event)=>{
          //파일이 로드되면
          this.crop_dialog_land = true;       //크롭팝업 띄우고
          this.imgSrc = event.target.result;  //이게 blob데이터
          //this.$refs.cropper_land.replace(event.target.result);
        }
        reader.readAsDataURL(this.uploadFile);  //비동기로 파일을 읽어서

      },
      cropimg(){
        //이미지 크롭 
        this.$refs.cropper_land.getCropBlob(blob=>{
          this.crop_dialog_land = false;
          this.uploadFile = blob; //크롭된 이미지의 blob데이터
          this.$refs.cropper_land.getCropData(data=>{
            this.previewImg = data; //이미지뷰 미리보기용
          });
        });
      },      


      checkRegNumber(){

        const numberVal = /^[0-9-]/;
        if(this.editedItem.REGNUMBER  == undefined || this.editedItem.REGNUMBER.length < 1 || this.editedItem.REGNUMBER.length > 20){
          this.$alert(this.$t('join_regnum_check1'));
          return;
        } 
        if(!numberVal.test(this.editedItem.REGNUMBER)){
          this.$alert(this.$t('join_regnum_check2'));
        }

        //사업자등록번호 중복 확인
        this.$http.post(this.$host+'/ime/CheckRegNumber',{
              REGNUMBER:this.editedItem.REGNUMBER
        })
        .then((result)=>{
          if(result.data.resultCode == 0){
              if(result.data.cnt == 0){
                //통과
                this.$alert(this.$t('join_regnum_pass'));
                this.CHECKREGNUMBER = this.editedItem.REGNUMBER;
              }else{
                //실패
                this.$alert(this.$t('join_regnum_fail'));
                this.CHECKREGNUMBER = "";
              }
          }else{
            this.$alert(this.$t('join_checkid_error'));
          }
        })
        .catch((error)=>{
          this.$alert(this.$t('join_checkid_error'));
        });        
      },



      createAPIKey(idx){

        this.close();
        
        this.$http.post(this.$host+'/api/createAPIKey',{
          IDX:idx
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
          if(result.data.resultCode == 0){
            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            this.$alert(this.$t('company_api_com')).then(()=>{
              const p = this.page;
              this.page = 0;
              this.loadpage(p);
            });

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동
          }else{
            this.$alert(this.$t('common_process_fail'));
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
          this.$alert(this.$t('common_process_fail'));
        });

      },

      postcodetoAddr(addr){
        this.editedItem.ADDR1 = addr;
      },

      //지도
      postcode(){

        //콜백에서 못찾아서 콘스트로 미리 빼둔다.
        const callback_addrfunction     = this.postcodetoAddr;

        new daum.Postcode({
            oncomplete: function(data) {
                var addr = data.address; // 최종 주소 변수
                if(data.userSelectedType == "J"){
                  //지번
                  addr = data.jibunAddress; 
                }
                //주소 정보를 해당 필드에 넣는다.
                callback_addrfunction(addr);
            }
        }).open();

      },


      //상태값변경
      setstatecom(item){
        this.editedIndex = this.itemList.indexOf(item)
        this.editedItem = Object.assign({}, item);
        this.dialogstate = true;
      },

      customsort(sortname){
        this.sort_name = sortname;
        this.sort_type = !this.sort_type;
        this.loadpage(this.page);
      },

      prev(){
          this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage(temp_page);
      },
      next(){
          this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage;
          this.loadpage(temp_page);
      },

      makepaging(){
        var div1 = this.totalcnt / this.pagerow; 
        var div2 = this.totalcnt % this.pagerow;
        if(div2 == 0){  
            this.maxpage = parseInt(div1);    
        }else{
            this.maxpage = parseInt(div1+1);
        }
        if(this.bottompage == 1){
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        }
      },

      //조회
      loadpage(p){

          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/CompanyList',{
                search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , sort_name:this.sort_name
              , sort_type: this.sort_type==true ? "DESC" : "ASC" 
              , page: this.page
              , pagerow: this.pagerow
              , ADMIN_IDX:this.$session.get("ADMIN_IDX")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{

            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

                this.totalcnt = result.data.totalcnt;
                this.makepaging();
                const list = result.data.resultData;
                this.itemList.splice(0, this.itemList.length);   //데이터 초기화
                list.forEach(element => {
                    this.itemList.push(element); 
                });
                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      async initpage(){

        //첫페이지 로드
        this.loadpage(1);

      },      

      //다이얼로그 닫기
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.uploadFile = null;
        }, 300)
      },

      //추가 및 수정
      async save(){

        if(this.editedItem.NAME  == undefined || this.editedItem.NAME.length < 1){
          this.$alert(this.$t('join_comkor_holder'));
          return;
        } 
        if(this.editedItem.ENAME  == undefined || this.editedItem.ENAME.length < 1){
          this.$alert(this.$t('join_comeng_holder'));
          return;
        } 
        if(this.editedItem.CEONAME  == undefined || this.editedItem.CEONAME.length < 1){
          this.$alert(this.$t('join_ceo_holder'));
          return;
        } 

        const telVal = /^[0-9+-]{5,20}/;
        if(this.editedItem.TEL  == undefined || this.editedItem.TEL.length < 1 || this.editedItem.TEL.length > 20){
          this.$alert(this.$t('join_sendjoin_tel1'));
          return;
        } 
        if(!telVal.test(this.editedItem.TEL)){
          this.$alert(this.$t('join_sendjoin_tel2'));
          return;
        } 
        
        //var emailVal = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
        var emailVal = /^[0-9a-zA-Z][-_.0-9a-zA-Z]*@[0-9a-zA-Z][-_.0-9a-zA-Z]*(\.[a-zA-Z]{2,})+$/i;
        if(this.editedItem.EMAIL  == undefined || this.editedItem.EMAIL.length < 1 || this.editedItem.EMAIL.length > 30){
          this.$alert(this.$t('join_sendjoin_email1'));
          return;
        } 
        if(!emailVal.test(this.editedItem.EMAIL)){
          this.$alert(this.$t('join_sendjoin_email2'));
          return;
        } 

        var mobileVal = /^\d{3}-?\d{3,4}-?\d{4}$/;
        if(this.editedItem.MOBILE  == undefined || this.editedItem.MOBILE.length < 1 || this.editedItem.MOBILE.length > 20){
          this.$alert(this.$t('join_sendjoin_mobile1'));
          return;
        } 
        if(!mobileVal.test(this.editedItem.MOBILE)){
          this.$alert(this.$t('join_sendjoin_mobile3'));
          return;
        } 


        if(this.editedItem.ADDR1  == undefined || this.editedItem.ADDR1.length < 1){
          this.$alert(this.$t('join_sendjoin_addr1'));
          return;
        } 
        if(this.editedItem.ADDR2  == undefined || this.editedItem.ADDR2.length < 1  || this.editedItem.ADDR2.length > 50){
          this.$alert(this.$t('join_sendjoin_addr2'));
          return;
        } 

        
        if(this.editedItem.REGNUMBER  == undefined || this.editedItem.REGNUMBER.length < 1 || this.editedItem.REGNUMBER.length > 20){
          this.$alert(this.$t('join_sendjoin_regnum1'));
          return;
        } 

        const numberVal = /[^0-9-]/g;
        if(numberVal.test(this.editedItem.REGNUMBER)){
          this.$alert(this.$t('join_sendjoin_regnum2'));
           return;
        }
        if(this.editedItem.REGNUMBER != this.CHECKREGNUMBER){
          this.$alert(this.$t('join_sendjoin_regnum3'));
          return;
        }
        if(this.editedItem.BANKTYPE  == undefined || this.editedItem.BANKTYPE.length < 1){
          this.$alert(this.$t('join_sendjoin_bank'));
          return;
        } 
        if(this.editedItem.BANKNUMBER  == undefined || this.editedItem.BANKNUMBER.length < 1 || this.editedItem.BANKNUMBER.length > 30){
          this.$alert(this.$t('join_sendjoin_banknum1'));
          return;
        } 
        if(numberVal.test(this.editedItem.BANKNUMBER)){
          this.$alert(this.$t('join_sendjoin_banknum2'));
           return;
        }

        // s3에 파일 업로드 - company 폴더에 이미지를 올린다.
        var albumPhotosKey = encodeURIComponent("company") + "/";
        
        const cb_getLastPath = this.getLastPath;

        //썸네일 이미지
        if(this.selectFile != null){
          var extens    = this.selectFile.split(".");
          let extension = extens[extens.length-1];
          var filename  = Date.now().toString()+"_thum."+extension;
          var photoKey  = albumPhotosKey + filename;   
          const temp_blob = this.uploadFile;
          const stored1 = await this.$s3.upload({
                                                Bucket: "blueorigin-mice-image",
                                                Key: photoKey,
                                                Body: temp_blob,
                                                ACL: "public-read"
                                              }).promise();
          //console.log("stored : " + JSON.stringify(stored1));                                              
          this.FILEPATH1 = stored1.Location;
          //console.log("FILEPATH1 : " + this.FILEPATH1);

          //기존 이미지 제거
          if(this.editedItem.LOGO != null && this.editedItem.LOGO != undefined && this.editedItem.LOGO.length > 0){
            var delete_filename = await cb_getLastPath(this.editedItem.LOGO);
            var delete_photoKey = albumPhotosKey + delete_filename;
            await this.delete_image(delete_photoKey);
          }

        }


        //사업자 등록증 파일
        if(this.uploadFile2 != null){
          var extens    = this.uploadFile2.name.split(".");
          let extension = extens[extens.length-1];
          var filename = Date.now().toString()+"_breg."+extension;
          var photoKey = albumPhotosKey + filename;   

          const stored2 = await this.$s3.upload({
                                                Bucket: "blueorigin-mice-image",
                                                Key: photoKey,
                                                Body: this.uploadFile2,
                                                ACL: "public-read"
                                              }).promise();
          
          this.FILEPATH2 = stored2.Location;
          //console.log("FILEPATH2 : " + this.FILEPATH2);

          //기존 이미지 제거
          if(this.editedItem.REGIMG != null && this.editedItem.REGIMG != undefined && this.editedItem.REGIMG.length > 0){
            var delete_filename = await this.getLastPath(this.editedItem.REGIMG);
            var delete_photoKey = albumPhotosKey + delete_filename;
            await this.delete_image(delete_photoKey);
          }
        }

        //통장사본 파일
        if(this.uploadFile3 != null){
          var extens2    = this.uploadFile3.name.split(".");
          let extension2 = extens2[extens2.length-1];
          var filename2 = Date.now().toString()+"_bank."+extension2;
          var photoKey2 = albumPhotosKey + filename2;   

          const stored3 = await this.$s3.upload({
                                                Bucket: "blueorigin-mice-image",
                                                Key: photoKey2,
                                                Body: this.uploadFile3,
                                                ACL: "public-read"
                                              }).promise();
          
          this.FILEPATH3 = stored3.Location;
          //console.log("FILEPATH3 : " + this.FILEPATH3);

          //기존 이미지 제거
          if(this.editedItem.BANKIMG != null && this.editedItem.BANKIMG != undefined && this.editedItem.BANKIMG.length > 0){
            var delete_filename = await this.getLastPath(this.editedItem.BANKIMG);
            var delete_photoKey = albumPhotosKey + delete_filename;
            await this.delete_image(delete_photoKey);
          }
        }

        if (this.editedIndex > -1) {


          //console.log("this.editedItem.API_STATE : " + this.editedItem.API_STATE);

          //수정
          this.loading = true;
          this.$http.post(this.$host+'/api/CompanyUpdate',{
                COM_IDX: this.editedItem.IDX
              , NAME: escape(this.editedItem.NAME)
              , ENAME: escape(this.editedItem.ENAME)
              , CEONAME: escape(this.editedItem.CEONAME)
              , TEL: escape(this.editedItem.TEL)
              , EMAIL: escape(this.editedItem.EMAIL)
              , MOBILE: escape(this.editedItem.MOBILE)
              , ADDR1: escape(this.editedItem.ADDR1)
              , ADDR2: escape(this.editedItem.ADDR2)
              , REGNUMBER: escape(this.editedItem.REGNUMBER)
              , BANKTYPE: escape(this.editedItem.BANKTYPE)
              , BANKNUMBER: escape(this.editedItem.BANKNUMBER)
              , FILEPATH1: this.FILEPATH1
              , FILEPATH2: this.FILEPATH2
              , FILEPATH3: this.FILEPATH3
              , API_STATE: this.editedItem.API_STATE
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_edit_msg")).then(()=>{
                const p = this.page;
                this.page = 0;
                this.loadpage(p);
              });
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener")).then(()=>{
                this.$session.clear("ADMIN_IDX");
                this.$session.clear("COM_IDX");
                this.$session.clear("ACNT_IDX");
                this.$session.clear("GRADE");
                this.$session.clear("COM_NAME");
                this.$session.clear("ACCESSTOKEN");
                this.$session.clear("REFLASHTOKEN");
                this.$router.push('Login');   //로그인 페이지로 이동
              });
            }else{
                this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });

        }else{

          //신규 - 사용안함.
          this.loading = true;
          const formData = new FormData();
          formData.append("FOLDER", "company");
          formData.append("NAME",       this.editedItem.NAME);
          formData.append("LOGO",       this.editedItem.LOGO);
          formData.append("ADMIN_IDX",  this.$session.get("ADMIN_IDX"));
          formData.append("customfile", this.uploadFile);
          this.$http.post(this.$host+'/api/CompanyInsert', formData, {
            headers:{'Content-Type': 'multipart/form-data',accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}
          })
          .then((result)=>{
            
            this.loading = false;
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                this.$alert(this.$t("common_insert_msg")).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_insert_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_insert_fail"));
          });
        }

        this.close()  //팝업닫기
      },      

      //url의 마지막 /이후의 값을 가져온다.
      async getLastPath(path_url){
        var array = path_url.split('/');
        return array[array.length-1];
      },

      //검색버튼 클릭
      search_run(){
        this.loadpage(1);
      },

      //신규 추가
      newinsert(){
        this.dialogTitle  = this.$t('common_insert_title');
        this.editedIndex  = -1;
        this.editedItem   = Object.assign({}, this.defaultItem)
        this.dialog = true;
      },

      //아이템 수정
      edit_item(item){
        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = this.itemList.indexOf(item)
        //this.editedItem = item;
        this.editedItem = Object.assign({}, item);
        this.CHECKREGNUMBER = this.editedItem.REGNUMBER;
        this.FILEPATH1 = this.editedItem.LOGO;
        this.previewImg = this.editedItem.LOGO;
        this.FILEPATH2 = this.editedItem.REGIMG;
        this.FILEPATH3 = this.editedItem.BANKIMG;
        this.uploadFile = null;
        this.uploadFile2 = null;
        this.uploadFile3 = null;
        this.dialog = true;
      },

      //아이템 삭제
      delete_item(item){

        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          
          this.loading = true;
          this.$http.post(this.$host+'/api/CompanyDelete',{
                COM_IDX:item.IDX
              , ADMIN_IDX:this.$session.get("ADMIN_IDX")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              const p = this.page;
              this.page = 0;
              this.$alert(this.$t("common_delete_com")).then(()=>{
                this.loadpage(p);
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      
        });

      },



      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
        }
        this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
        this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.loadpage(1);
      },
      
      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_COM_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.loadpage(1);
      },

      async delete_image(key){
        const temp = await this.$http.post(this.$host+'/api/DeleteImage',{deletekey:key},{headers:{accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}});
        return temp;
      }



    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>


</style>